<div class="d-inline-flex {{ reverse ? 'flex-row-reverse' : 'flex-row' }} justify-content-between align-items-{{ verticalAlign }}">
  <img *ngIf="imageSrc" [src]="imageSrc" [alt]="imageAlt">
  <ng-content select=".image"></ng-content>
  <div [class]="labelClass">
    <ng-content></ng-content>
  </div>
</div>
